<template>
  <div class="event-full-nav-current">
    <div>{{ label }}</div>
  </div>
</template>

<script>
export default {
  props: {
    anchors: Array
  },
  data() {
    return {
      label: ''
    }
  },
  mounted() {
    window.addEventListener('scroll', this.setCurrentSection)
    window.addEventListener('resize', this.setCurrentSection)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.setCurrentSection)
    window.removeEventListener('resize', this.setCurrentSection)
  },
  methods: {
    setCurrentSection() {
      let anchors = []

      this.anchors.forEach((item, index) => {
        const anchor = document.querySelector(`#${item.id}`)

        anchors.push({
          index,
          item,
          offset: anchor.getBoundingClientRect().top
        })
      })

      anchors = anchors.filter(anchor => anchor.offset < 10)

      if (anchors.length) {
        const anchor = anchors.pop()
        this.label = anchor.item.label
        this.$emit('setCurrent', anchor.index)
      } else {
        this.label = ''
        this.$emit('setCurrent', null)
      }
    }
  }
}
</script>
